import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  TabContent,
  TabPane,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
  Row,
  Col,
  Collapse
} from 'reactstrap';
import { NavLink } from 'react-router-dom';
import { getAccount } from '../account/_selectors';
import Terms from './Terms';
import { apiService } from 'utils/api';

class Legal extends Component {
  constructor() {
    super();

    this.state = {
      content: [
        { key: 'privacy_policy', title: 'Privacy Policy', path: 'privacy-policy', text: '' },
        {
          key: 'terms_and_conditions',
          title: 'Terms of Service',
          path: 'terms-of-service',
          text: ''
        },
        {
          key: 'business_agreement',
          title: 'Business Agreement',
          path: 'business-agreement',
          text: ''
        },
        { key: 'dmca_policy', title: 'DMCA Policy', path: 'dmca-policy', text: '' },
        { key: 'acceptable_use', title: 'Acceptable Use', path: 'acceptable-use', text: '' },
        { key: 'use_of_cookies', title: 'Use of Cookies', path: 'use-of-cookies', text: '' }
      ],
      isOpen: false
    };

    this.toggleNavbar = this.toggleNavbar.bind(this);
  }

  toggleNavbar() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  acceptTerms() {
    this.setState({ loading: true });
    this.props.acceptTerms().then(() => this.setState({ loading: false }));
  }

  getUrlParameter(name) {
    const n = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp('[\\?&]' + n + '=([^&#]*)');
    const results = regex.exec(this.props.location.search);

    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  isActive = (match, location, element) => {
    return this.props.location.pathname.indexOf(element.path) !== -1;
  };

  componentDidMount() {
    if (this.getUrlParameter('mobile')) {
      document.body.classList.add('mobile-legal-view');
    } else {
      document.body.classList.remove('mobile-legal-view');
    }

    apiService.get('/terms').then(res => {
      const content = this.state.content.map(c => ({ ...c, text: res.data[c.key] }));
      this.setState({ content });
    });
  }

  render() {
    const activeTab =
      this.props.match.params.page !== undefined
        ? this.state.content.findIndex(c => c.path === this.props.match.params.page)
        : 1;

    return this.state.content[activeTab] ? (
      <div className="legal-wrapper pt-0 pt-lg-8">
        <Row>
          <Col lg="3">
            <Navbar expand="lg" className="with-background-legal with-light-bg p-0">
              <NavbarToggler
                onClick={this.toggleNavbar}
                className={
                  'd-flex d-lg-none align-items-center justify-content-between text-left px-0 w-100 btn' +
                  (this.state.isOpen ? ' show' : '')
                }
              >
                <h3 className="m-0">{this.state.content[activeTab].title}</h3>
              </NavbarToggler>
              <Collapse
                id="tabsMenu"
                isOpen={this.state.isOpen}
                className="justify-content-between align-items-start navbar-collapse"
              >
                <Nav tabs className="w-100">
                  {this.state.content.map((element, i) => (
                    <NavItem key={i}>
                      <NavLink
                        className="nav-link"
                        to={`/legal/${element.path}${this.props.location.search}`}
                        isActive={(match, location) => this.isActive(match, location, element)}
                        onClick={this.toggleNavbar}
                      >
                        {element.title}
                      </NavLink>
                    </NavItem>
                  ))}
                </Nav>
              </Collapse>
            </Navbar>
          </Col>
          <Col>
            <TabContent activeTab={activeTab} className="mt-2 mt-lg-0">
              {this.state.content.map((element, i) => (
                <TabPane tabId={i} key={i} className="pb-8 pb-md-0">
                  <Row>
                    <Col xl={{ size: 8, offset: 1 }}>
                      <Terms terms={element.text} />
                    </Col>
                  </Row>
                </TabPane>
              ))}
            </TabContent>
          </Col>
        </Row>
      </div>
    ) : null;
  }
}

function mapStateToProps(state) {
  return {
    account: getAccount(state)
  };
}

export default connect(
  mapStateToProps,
  {}
)(Legal);



// WEBPACK FOOTER //
// ./src/views/legal/Legal.js